module.exports = __webpack_public_path__ + "static/img/weather04.5a5b158b.png";